import React from "react";

export default function OceanWaveSection() {
  return (
    <section data-testid="ocean-wave-section" className="ocean-scene">

      {/* Layer 1 — deepest back, slowest */}
      <div className="wave-wrap wave-back-1">
        <svg className="wave-svg" viewBox="0 0 3600 200" preserveAspectRatio="none">
          <path d="M0,140 C180,110 360,160 540,130 C720,100 900,155 1080,135 C1260,115 1440,160 1620,130 C1800,100 1980,150 2160,135 C2340,120 2520,158 2700,130 C2880,102 3060,155 3240,135 C3420,115 3600,145 3600,140 L3600,200 L0,200 Z" />
        </svg>
        <svg className="wave-svg" viewBox="0 0 3600 200" preserveAspectRatio="none">
          <path d="M0,140 C180,110 360,160 540,130 C720,100 900,155 1080,135 C1260,115 1440,160 1620,130 C1800,100 1980,150 2160,135 C2340,120 2520,158 2700,130 C2880,102 3060,155 3240,135 C3420,115 3600,145 3600,140 L3600,200 L0,200 Z" />
        </svg>
      </div>

      {/* Layer 2 */}
      <div className="wave-wrap wave-back-2">
        <svg className="wave-svg" viewBox="0 0 3600 200" preserveAspectRatio="none">
          <path d="M0,148 C200,118 400,168 600,142 C800,116 1000,165 1200,145 C1400,125 1600,170 1800,142 C2000,114 2200,168 2400,148 C2600,128 2800,165 3000,142 C3200,119 3400,160 3600,148 L3600,200 L0,200 Z" />
        </svg>
        <svg className="wave-svg" viewBox="0 0 3600 200" preserveAspectRatio="none">
          <path d="M0,148 C200,118 400,168 600,142 C800,116 1000,165 1200,145 C1400,125 1600,170 1800,142 C2000,114 2200,168 2400,148 C2600,128 2800,165 3000,142 C3200,119 3400,160 3600,148 L3600,200 L0,200 Z" />
        </svg>
      </div>

      {/* Layer 3 */}
      <div className="wave-wrap wave-mid">
        <svg className="wave-svg" viewBox="0 0 3600 200" preserveAspectRatio="none">
          <path d="M0,155 C150,132 330,172 540,150 C750,128 930,175 1140,155 C1350,135 1530,175 1740,152 C1950,129 2130,172 2340,155 C2550,138 2730,175 2940,152 C3150,129 3330,168 3600,155 L3600,200 L0,200 Z" />
        </svg>
        <svg className="wave-svg" viewBox="0 0 3600 200" preserveAspectRatio="none">
          <path d="M0,155 C150,132 330,172 540,150 C750,128 930,175 1140,155 C1350,135 1530,175 1740,152 C1950,129 2130,172 2340,155 C2550,138 2730,175 2940,152 C3150,129 3330,168 3600,155 L3600,200 L0,200 Z" />
        </svg>
      </div>

      {/* Layer 4 */}
      <div className="wave-wrap wave-front-1">
        <svg className="wave-svg" viewBox="0 0 3600 200" preserveAspectRatio="none">
          <path d="M0,162 C130,145 290,178 480,160 C670,142 850,180 1040,162 C1230,144 1410,178 1600,162 C1790,146 1970,180 2160,160 C2350,140 2530,178 2720,162 C2910,146 3090,175 3280,162 C3430,152 3600,168 3600,162 L3600,200 L0,200 Z" />
        </svg>
        <svg className="wave-svg" viewBox="0 0 3600 200" preserveAspectRatio="none">
          <path d="M0,162 C130,145 290,178 480,160 C670,142 850,180 1040,162 C1230,144 1410,178 1600,162 C1790,146 1970,180 2160,160 C2350,140 2530,178 2720,162 C2910,146 3090,175 3280,162 C3430,152 3600,168 3600,162 L3600,200 L0,200 Z" />
        </svg>
      </div>

      {/* Layer 5 — closest front, fastest + bob */}
      <div className="wave-wrap wave-front-2">
        <svg className="wave-svg" viewBox="0 0 3600 200" preserveAspectRatio="none">
          <path d="M0,170 C100,160 240,182 420,170 C600,158 780,184 960,172 C1140,160 1320,184 1500,170 C1680,156 1860,184 2040,172 C2220,160 2400,184 2580,170 C2760,156 2940,182 3120,172 C3300,162 3480,178 3600,170 L3600,200 L0,200 Z" />
        </svg>
        <svg className="wave-svg" viewBox="0 0 3600 200" preserveAspectRatio="none">
          <path d="M0,170 C100,160 240,182 420,170 C600,158 780,184 960,172 C1140,160 1320,184 1500,170 C1680,156 1860,184 2040,172 C2220,160 2400,184 2580,170 C2760,156 2940,182 3120,172 C3300,162 3480,178 3600,170 L3600,200 L0,200 Z" />
        </svg>
      </div>

      {/* Foam / shimmer at top of waves */}
      <div className="wave-foam" />
    </section>
  );
}
